import { apiClient } from '@/api/api-client'
import StoreService from '@/store/StoreService'

import { useDeleteTriviaList } from './useDeleteTriviaList'

export function useDeleteSystemTriviaList() {
  const { triviaListService } = StoreService.getStore()

  const mutationFn = (listId: string) => apiClient.systemDeleteTriviaList(listId)

  const { queries } = triviaListService
  const { queryFn, queryKey } = queries.systemTriviaLists

  return useDeleteTriviaList(mutationFn, queryKey, queryFn)
}
